import { createContext } from "react";

const HeaderTitleContext = createContext(null);

export default HeaderTitleContext;